const PortfolioData = [
  {
    id: 1,
    category: 'Web app',
    tech: 'Next.js | React | CMS Dashboard',
    title: 'TinCupPlus - Restaurant Menu Platform',
    image: '/proj/tincup.png',
    description: 'A restaurant menu website built with Next.js featuring a landing page, food menu display, and CMS dashboard for admins to manage menu posts and banners.',
    seelive: 'https://tincupplus.com/',
    seesource: '#',
  },
  {
    id: 2,
    category: 'E-commerce Platform',
    tech: 'React | Payment Integration | CMS Dashboard',
    title: 'YeneHealth - E-commerce Healthcare Platform',
    image: '/proj/yenehealth.png',
    description: 'A comprehensive e-commerce platform with product listing, blogs, and secure payment integration (Telebirr, Chappa, Safari, USSD push). Features role-based CMS for product management, order analytics, user management, and Telegram notifications.',
    seelive: 'https://yenehealth.com/',
    seesource: '#',
  },
  {
    id: 3,
    category: 'Business Platform',
    tech: 'React | Admin Dashboard | Analytics',
    title: 'SnapHub - Business Process Enhancement',
    image: '/proj/snaphub.png',
    description: 'A technology platform providing precision business process enhancement services for F&B, Utility, E-commerce, and Logistics sectors. Features landing page and admin dashboard for business tracking and management.',
    seelive: 'https://snaphub.tech/',
    seesource: '#',
  },
  {
    id: 4,
    category: 'Healthcare Dashboard',
    tech: 'React | Video Call | Chat | Payment System',
    title: 'YeneHealth Provider Dashboard',
    image: '/proj/provider.png',
    description: 'A comprehensive dashboard for healthcare professionals to manage patients, generate prescriptions, and conduct video/phone/chat consultations. Features integrated payment system for doctor compensation.',
    seelive: 'https://provider.yenehealth.com/',
    seesource: '#',
  },
  {
    id: 5,
    category: 'Web app',
    tech: 'React | Redux | PostgreSQL | Node.js | Express.js | TailwindCSS',
    title: 'easternlightpharma.com',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/dev/src/assets/images/project-screenshoot/easternlight2.png',
    description: 'A web app built with PERN stack for Eastern light Pharmaceutical and bio medical wholesaler that helps them to post there products and make uses to see the details of the products.',
    seelive: 'https://easternlightpharma.com/',
    seesource: '#',
  },
  {
    id: 6,
    category: 'Web site',
    tech: 'NextJs |React | Landing Page',
    title: 'Walia Nexus - Tech Company Landing',
    image: '/proj/walia.png',
    description: 'A professional landing page for a tech company featuring home page, about us section, and services page showcasing the company offerings.',
    seelive: 'https://walianexus.com/',
    seesource: '#',
  },
  {
    id: 7,
    category: 'Web site',
    tech: 'React',
    title: 'Cloud App',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/cloud.png',
    description: 'A Cloud Management website that has support and service pages built with TailwindCSS.',
    seelive: 'https://cloud-app-with-tailwind.vercel.app/',
    seesource: '#',
  },
  {
    id: 8,
    category: 'Web site',
    tech: 'JavaScript | HTML | CSS',
    title: ' ShowBox Movies.',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/movie.png',
    description: 'Search for info about your favorite movies and tv shows on the ShowBox Movie Database',
    seelive: 'https://deyemiobaa.github.io/Movie-Database/',
    seesource: '#',
  },
  {
    id: 9,
    category: 'Node package',
    tech: 'TypeScript',
    title: 'Random String Generator Package',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/random-string-gen.png',
    description: 'This package generates random strings based on the given parameters. There are lots of scenarios where you can use our Random string generator - the most known or best scenarios are: 1. Password generation, 2. Token generation, 3. Testing, 4. ID generation. This package has around 5000 downloads per week on npm. Getting Started: To start using this on your local machine, first test the program using test.js. Install node modules: npm install randomized-string or yarn add randomized-string.',
    seelive: 'https://www.npmjs.com/package/randomized-string',
    seesource: '#',
  },
];
export default PortfolioData;
